import { ApiTags } from '@/store/api/tags';

import { baseApi } from './baseApi';

export type PendingMetricsOffer = {
  offerId: number;
  ticker: string;
  resuretyExecutionId: number | null;
  companyName: string;
  projectName: string;
  technology: string;
  projectOperationalStatus: string;
  currentStatus: string;
  targetStatus: string | null;
  metricsFetchAttempts: number;
  /**
   * Attempts after which an offer is treated as needing attention. Not the pull
   * job's retry cap — the job may keep polling well past this point (PROD polls
   * for 24 hours but flags an offer as stuck after ~2).
   */
  stuckAfterAttempts: number;
  updatedAt: string;
  isStuck: boolean;
};

export type RetryMetricsResponse = {
  offerId: number;
  status: string;
  previousExecutionId: number | null;
  metricsFetchAttemptsReset: boolean;
  message: string;
};

export type RefreshAllMetricsResponse = {
  jobId: string;
  message: string;
  instructions: string;
};

const BASE_URL = '/api/v1/admin/actions';

export const keyMetricsAdminApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getPendingMetricsOffers: build.query<PendingMetricsOffer[], void>({
      query: () => `${BASE_URL}/offers/pending-metrics`,
      providesTags: [ApiTags.PENDING_METRICS],
    }),
    retryOfferMetrics: build.mutation<RetryMetricsResponse, number>({
      query: offerId => ({
        url: `${BASE_URL}/offers/${offerId}/retry-metrics`,
        method: 'POST',
      }),
      invalidatesTags: [ApiTags.PENDING_METRICS],
    }),
    repullOfferMetrics: build.mutation<RetryMetricsResponse, number>({
      query: offerId => ({
        url: `${BASE_URL}/offers/${offerId}/repull-metrics`,
        method: 'POST',
      }),
      invalidatesTags: [ApiTags.PENDING_METRICS],
    }),
    refreshAllMetrics: build.mutation<RefreshAllMetricsResponse, void>({
      query: () => ({
        url: `${BASE_URL}/metrics-refresh`,
        method: 'POST',
      }),
      invalidatesTags: [ApiTags.PENDING_METRICS],
    }),
  }),
});

export const {
  useGetPendingMetricsOffersQuery,
  useRetryOfferMetricsMutation,
  useRepullOfferMetricsMutation,
  useRefreshAllMetricsMutation,
} = keyMetricsAdminApi;
